export default "__VITE_ASSET__HvmYeXUR__"